import { render, staticRenderFns } from "./IconDocument.vue?vue&type=template&id=6d2b7880"
import script from "./IconDocument.vue?vue&type=script&lang=ts"
export * from "./IconDocument.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports